export const PRACTICE_TEST = [
    {
        id: 1,
        test_name: 'Assessment Test',
        use_practice_test_id: true,
        practice_test_id: 1,
        requires_subscription: false
    },
    {
        id: 2,
        test_name: 'Practice Test 1',
        use_practice_test_id: true,
        practice_test_id: 2,
        requires_subscription: true
    },
    {
        id: 3,
        test_name: 'Practice Test 2',
        use_practice_test_id: true,
        practice_test_id: 3,
        requires_subscription: true
    },
    {
        id: 4,
        test_name: 'Practice Test 3',
        use_practice_test_id: true,
        practice_test_id: 4,
        requires_subscription: true
    },
    {
        id: 5,
        test_name: 'Practice Test 4',
        use_practice_test_id: true,
        practice_test_id: 5,
        requires_subscription: true
    },
    {
        id: 6,
        test_name: 'Practice Test 5',
        use_practice_test_id: true,
        practice_test_id: 6,
        requires_subscription: true
    },
    {
        id: 7,
        test_name: 'Practice Test 6',
        use_practice_test_id: true,
        practice_test_id: 7,
        requires_subscription: true
    }
];

// CompTIA DataAI (DY0-001) exam domains — topic_id 1–5 in the content map to these
// five domains (official CompTIA order/weighting). num_* are the free-tier per-domain
// access caps (first domain free, rest gated), mirroring the other bundle exams.
export const APP_DOMAIN_LIST = [
    {
        id: 1,
        domain_name: "Mathematics and Statistics",
        show_proficiency: true,
        icon: 'calculator-variant',
        requires_subscription: false,
        num_questions: 5,
        num_flashcards: 5,
        num_articles: 5,
    },
    {
        id: 2,
        domain_name: "Modeling, Analysis, and Outcomes",
        show_proficiency: true,
        icon: 'chart-line',
        requires_subscription: true,
        num_questions: 5,
        num_flashcards: 5,
        num_articles: 5,
    },
    {
        id: 3,
        domain_name: "Machine Learning",
        show_proficiency: true,
        icon: 'robot',
        requires_subscription: true,
        num_questions: 5,
        num_flashcards: 5,
        num_articles: 5,
    },
    {
        id: 4,
        domain_name: "Operations and Processes",
        show_proficiency: true,
        icon: 'cog',
        requires_subscription: true,
        num_questions: 5,
        num_flashcards: 5,
        num_articles: 5,
    },
    {
        id: 5,
        domain_name: "Specialized Applications of Data Science",
        show_proficiency: true,
        icon: 'star-cog',
        requires_subscription: true,
        num_questions: 5,
        num_flashcards: 5,
        num_articles: 5,
    }
];

export const QUESTION_VERSION_OF_JSON = 1
